<template>
  <form :id="`frm-${id}`" class="px-3" method="post" @submit.prevent="saveFiles">
    <div
      aria-hidden="true"
      aria-labelledby="fileModalTitle"
      class="modal fade file-modal"
      :id="id"
      role="dialog"
      tabindex="-1">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header modal-body-scrolled pb-0">
            <h5 class="modal-title" id="exampleModalLongTitle">{{ title }}</h5>
          </div>
          
          <div class="modal-body overflow-x-hidden">
            <p v-if="message">{{ message }}</p>
            
            <div class="form-group row">
              <div class="card card-fluid shadow-none w-100 mb-0">
                <div class="card-body">
                  
                  <div v-if="!multiple">
                    <label>Seleccione el archivo</label>
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" id="upload-file" multiple="" @change="filesSelected">
                      <label class="custom-file-label" for="upload-file">Seleccionar archivo</label>
                    </div>
                  </div>
                  
                  <div v-else>
                    <div class="btn btn-secondary fileinput-button">
                      <i class="fa fa-plus fa-fw"></i> <span>Seleccionar los archivos</span>
                      <input id="fileupload-btn" type="file" name="files[]" multiple="" @change="filesSelected">
                    </div>
                  </div>
                </div>
                
                <hr v-if="sending || selectedFiles.length">
                
                <div id="progress" class="progress progress-xs rounded-0 fade" v-if="sending">
                  <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
                       aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <div id="uploadList" class="list-group list-group-flush list-group-divider" v-if="selectedFiles.length">
                  <div class="list-group-item" v-for="file in selectedFiles"
                       :key="file.id">
                    <div class="list-group-item-figure">
                      <div class="tile tile-img">
                        <span class="fas fa-file-pdf fa-lg text-red"></span>
                      </div>
                    </div>
                    <div class="list-group-item-body">
                      <div class="media align-items-center">
                        <div class="media-body">
                          <a target="_blank"
                             href="#" @click.prevent="">{{ file.name }}</a>
                        </div>
                        <div class="media-actions">
                          <button class="btn btn-sm btn-secondary" type="button">Eliminar</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="modal-footer flex justify-content-between px-2 shadow-none">
            <button class="btn btn-primary" type="button" :disabled="selectedFiles.length === 0"
                    @click.prevent="saveFiles">Adjuntar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import { AlertManager } from './utils/AlertManager'
  
  export default {
    name: 'FileModal',
    props: {
      message: String,
      title: {
        type: String,
        default: 'Adjuntar archivo',
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      id: {
        type: String,
        default: Math.guid(),
      },
    },
    data() {
      return {
        radio: null,
        target: null,
        info: null,
        sending: false,
        selectedFiles: [],
      }
    },
    methods: {
      filesSelected(e) {
        const files = e.target.files
        
        Array.from(files).forEach(file => {
          if(file.type.indexOf('pdf') === -1) {
            AlertManager.error(`El formato del archivo ${file.name} no es aceptado. Seleccione un archivo PDF`, {
              timeout: 10000,
            })
            
            return false
          }
          
          this.addFile(file)
        })
      },
      addFile(file) {
        const { name, type, size } = file
        
        if(this.multiple) {
          this.selectedFiles.push({
            id: Math.guid(),
            name,
            type,
            size,
          })
        }
        else {
          this.selectedFiles = [{
            id: Math.guid(),
            name,
            type,
            size,
          }]
        }
      },
      
      _saveFiles() {
        let clone = $('#fileModal input[data-id="' + this.target + '_aux"]').clone()
        $('input[data-id="' + this.target + '"]').remove()
        clone.addClass('d-none').attr('data-id', this.target).insertAfter($('.file-btn[data-target="' + this.target + '"]'))
        $('.' + this.info).removeClass('d-none').find('.text').text(clone.prop('files')[0].name)
        $('#fileModal').modal('hide')
        this.radio.prop({
          'checked': true,
          'disabled': true,
        })
      },
      clearModal() {
        $('#fileModal input[data-id="' + this.target + '_aux"]').remove()
        this.target = null
        this.text   = null
      },
      removeFile(removeBtn) {
        let radio = $('#' + removeBtn.attr('data-target'))
        radio.prop({
          'checked': false,
          'disabled': false,
        })
        $('input[data-id="' + radio.attr('data-target') + '"]').val(null)
        removeBtn.parent().addClass('d-none').find('.text').text('')
      },
    },
    mounted() {
      const vm = this
      
      /**
       * Open modal
       */
      $('body').on('click', '.file-btn', function(e) {
        e.preventDefault()
        
        let target = $(this).attr('data-target')
        let text   = $(this).attr('data-text')
        let info   = $(this).attr('data-info')
        
        vm.radio  = $(this)
        vm.target = target
        vm.text   = text
        vm.info   = info
        
        let input = $('input[data-id="' + target + '"]')
        let clone = $(input).clone()
        clone.attr('data-id', target + '_aux').appendTo($('#file-container')).removeClass('d-none')
        
        $('#fileModal').modal('show')
      })
      
      /**
       * On hide modal
       */
      $('#fileModal').on('hidden.bs.modal', function(e) {
        vm.clearModal()
      })
      
      /**
       * Remove current file
       */
      $('body').on('click', '.remove-file', function() {
        vm.removeFile($(this))
      })
    },
  }
</script>
